import React, { Component } from "react";
import classnames from "classnames";
import { connect } from "react-redux";
import { showMainErrorPop } from '../../actions/popups';

import axiosVirdioT from '../../utils/axios';
var axiosVirdio;

class FitnessInfo extends Component {
  
  constructor(props) {
	super(props);
	
	this.state={
		userCategories: [],
		userMusic: [],
		userWeeklyGoal: 0,
		userGoals: [],
		isEdit: false,
		tempEditCategories: [],
		tempEditMusic: [],
		tempWeeklyGoal: 0,
		tempEditGoals: [],
		virdioCategories: [],
		virdioMusic: [],
		virdioGoals: [],
		isOpenEdit: false
    }
	
}
 
componentDidMount(){
	axiosVirdio = new axiosVirdioT(this.props);
	this.getFitnessCategories();
	this.getUserFitnessInfo();
}

getFitnessCategories=()=>{
	axiosVirdio.post(process.env.REACT_APP_API_URL+"/api/v1/user/getFitnessCategories").then(res => { 
		this.setState({
			virdioCategories: res.data.responseData.virdioCategories,
			virdioMusic: res.data.responseData.virdioMusic,
			virdioGoals: res.data.responseData.virdioGoals
		});
	}).catch(err =>{ });	
}

getUserFitnessInfo=()=>{
	let token = JSON.parse(localStorage.getItem('userData')).token;
    axiosVirdio.auth(token);
	axiosVirdio.post(process.env.REACT_APP_API_URL+"/api/v1/user/getUserFitnessInfo").then(res => { 
		this.setState({
			userCategories: res.data.responseData.userCategories,
			userMusic: res.data.responseData.userMusic,
			userGoals: res.data.responseData.userGoals,
			userWeeklyGoal: res.data.responseData.userWeeklyGoal,
			isOpenEdit: false
		});
		
		this.props.updateStateFromChild({showLoader: false});
	}).catch(err =>{ this.props.updateStateFromChild({showLoader: false}); });	
}

openEdit=()=>{
	var categoryIds = [];
	var musicIds = [];
	var goalIds = [];
	var userWeeklyGoalVar = this.state.userWeeklyGoal;
	
	if ( this.state.userCategories.length > 0 )
		{
			for ( let i = 0; i < this.state.userCategories.length; i++ )
				{
					categoryIds.push(this.state.userCategories[i].id);
				}
		}
		
	if ( this.state.userMusic.length > 0 )
		{
			for ( let i = 0; i < this.state.userMusic.length; i++ )
				{
					musicIds.push(this.state.userMusic[i].id);
				}
		}
		
	if ( this.state.userGoals.length > 0 )
		{
			for ( let i = 0; i < this.state.userGoals.length; i++ )
				{
					goalIds.push(this.state.userGoals[i].id);
				}
		}
	
	this.setState({
		tempEditCategories: categoryIds,
		tempEditMusic: musicIds,
		tempEditGoals: goalIds,
		tempWeeklyGoal: userWeeklyGoalVar,
		isOpenEdit: true
	});
}

updateInfo=(mainArray, editArray, i)=>{
	var arrayMain = this.state[mainArray];
	var arrayEdit = this.state[editArray];

	if ( arrayEdit.indexOf(arrayMain[i].id) == -1 )
		{
			arrayEdit.push(arrayMain[i].id);
		}
	else
		{
			var indexOf = arrayEdit.indexOf(arrayMain[i].id);
			arrayEdit.splice(indexOf, 1);
		}

	this.setState({[editArray]: arrayEdit})
}

submitEdit=()=>{
	var canSubmitForm = true;

	if ( isNaN(this.state.tempWeeklyGoal) || this.state.tempWeeklyGoal < 0 || this.state.tempWeeklyGoal == "" )
		{
			this.props.showMainErrorPop('Please add valid number for How many times in a week do you want to work out');
			canSubmitForm = false;
		}
		
	if ( canSubmitForm )
		{
			this.props.updateStateFromChild({showLoader: true});
			var postData = { 
							userCategories:  this.state.tempEditCategories,
							userMusic: this.state.tempEditMusic,
							userGoals: this.state.tempEditGoals,
							userWeeklyGoal: parseInt(this.state.tempWeeklyGoal)
						};
						
			let token = JSON.parse(localStorage.getItem('userData')).token;
			axiosVirdio.auth(token);
			axiosVirdio.post(process.env.REACT_APP_API_URL+"/api/v1/user/saveUserFitness", postData).then(res => {
				this.getUserFitnessInfo();
				this.props.showMainErrorPop("You successfully saved your Fitness Info");
			}).catch(err =>{ this.props.updateStateFromChild({showLoader: false}); });	
		}
}

  render() {
	 return (
		<div className="relative_settings_content">
			{ !this.state.isOpenEdit &&
				<div>
					<div className="settings_button" onClick={this.openEdit}>EDIT</div>
					<div className="saved_info saved100">
						<div className="saved_info_title">Preferred Categories</div>
						{ this.state.userCategories.length == 0 && <div className="saved_info_content">-</div> }
						{ this.state.userCategories.length > 0 &&
							<div className="saved_info_content">
								{ this.state.userCategories.map((item, i) =>
									<span key={i}>
										<span>{item.title}</span>
										{ (i < (this.state.userCategories.length -1)) && <span>, </span> }
									</span>
								)}
							</div>
						}
					</div>
					<div className="saved_info saved100">
						<div className="saved_info_title">Preferred Music</div>
						{ this.state.userMusic.length == 0 && <div className="saved_info_content">-</div> }
						{ this.state.userMusic.length > 0 &&
							<div className="saved_info_content">
								{ this.state.userMusic.map((item, i) =>
									<span key={i}>
										<span>{item.name}</span>
										{ (i < (this.state.userMusic.length -1)) && <span>, </span> }
									</span>
								)}
							</div>
						}
					</div>
					<div className="saved_info saved100">
						<div className="saved_info_title">Weekly Goal</div>
						<div className="saved_info_content">{this.state.userWeeklyGoal == 0 ? '-' : this.state.userWeeklyGoal}</div>
					</div>
					<div className="saved_info saved100">
						<div className="saved_info_title">Personal Goal</div>
						{ this.state.userGoals.length == 0 && <div className="saved_info_content">-</div> }
						{ this.state.userGoals.length > 0 &&
							<div className="saved_info_content">
								{ this.state.userGoals.map((item, i) =>
									<span key={i}>
										<span>{item.name}</span>
										{ (i < (this.state.userGoals.length -1)) && <span>, </span> }
									</span>
								)}
							</div>
						}
					</div>
				</div>
			}
			{ this.state.isOpenEdit &&
				<div>
					<div className="settings_button" onClick={this.submitEdit}>SAVE</div>
					<div className="one_fitness_edit">
						<div className="saved_info_title pb10">Preferred Categories</div>
						{ this.state.virdioCategories.map((item, i) =>
							<div className={classnames({'category_profile': true, 'active': this.state.tempEditCategories.indexOf(item.id) > -1})} key={i} onClick={() => this.updateInfo('virdioCategories', 'tempEditCategories', i)}>
								<div className="interest_icon" style={{ backgroundImage: "url("+item.icon+")"}}></div>
								<div className="category_title">{item.title}</div>
							</div>
						)}
					</div>
					<div className="one_fitness_edit">
						<div className="saved_info_title pb10">Music Preference</div>
						{ this.state.virdioMusic.map((item, i) =>
							<div className={classnames({'one_preference': true, 'active': this.state.tempEditMusic.indexOf(item.id) > -1})} key={i} onClick={() => this.updateInfo('virdioMusic', 'tempEditMusic', i)}>{item.name}</div>
						)}
					</div>
					<div className="one_fitness_edit">
						<div className="saved_info_title pb10">How many times in a week do you want to work out?</div>
						<input type="number" className="fitness_input" id="tempWeeklyGoal" value={this.state.tempWeeklyGoal} onChange={(e) => this.setState({[e.target.id]: e.target.value})} />
						<div className="number_input_title">times</div>
					</div>
					<div className="one_fitness_edit">
						<div className="saved_info_title pb10">What is your personal goal with Virdio?</div>
						{ this.state.virdioGoals.map((item, i) =>
							<div className={classnames({'one_preference': true, 'goal_preference': true, 'active': this.state.tempEditGoals.indexOf(item.id) > -1})} key={i} onClick={() => this.updateInfo('virdioGoals', 'tempEditGoals', i)}>{item.name}</div>
						)}
					</div>
				</div>
			}
		</div>
    );
  }
}

export default connect(
  null,
  { 
	showMainErrorPop
  }
)(FitnessInfo);
